import React, { useState } from "react";
import "./Cart.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CartCatalogStatus from "./CartCatalogStatus";
import useRecentlyViewed from "../../utils/useRecentlyViewed";
import CartTable from "./CartTable"; // Component to display the cart items in table format
import CartTotal from "./CartTotal"; // Component to display total price and actions
import LoginForm from "./LoginForm"; // Separate LoginForm Component
import SignupForm from "../Auth/SignupForm"; // Separate SignupForm Component
import { useTranslation } from "react-i18next";
import { useGetRandomQuery } from "../../redux/Apis/Products";

import ProductSlider from "../Trending/ProductSlider";


const CartContainer = () => {
  const nav = useNavigate();
  const cartItems = useSelector((state) => state.cartSlice.items); // Get cart items from Redux store
  const { t } = useTranslation();
  const [open, setOpen] = useState(false); // State to control the modal visibility
  const [tabIndex, setTabIndex] = useState(0); // State to control which tab is selected

  const {
    data: randomProductsResponse,
  } = useGetRandomQuery();
  const randomProducts = randomProductsResponse?.data?.products || []; // Ensure it's an array


  const isCookieConsentAccepted = useSelector(
    (state) => state.cookieConsent.isAccepted
  );

  const recentlyViewedProducts = useRecentlyViewed(isCookieConsentAccepted);
  const catalogStatus = useSelector(state => state.cartSlice.catalogStatus);

  const handleCheckout = () => {
    // if (!isLoggedIn) {
    //     setOpen(true); // Show modal if not logged in
    // } else {
    nav("/auth/checkout"); // Proceed to checkout if logged in
    // }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="container ">
      {/* Header Section */}
      <div className="checkout-nav text-center ">
        <h1 className="checkout-heading">{t("ShopCart")}</h1>
      </div>

      <CartCatalogStatus />
      <div className="row">
        {/* Cart Items Section */}
        <div className="col-lg-8 mb-4">
          <div className="card p-4">
            <h4 className="section-heading">{t("CartItems")}</h4>
            <hr className="my-3" />
            <CartTable cartItems={cartItems} />{" "}
            {/* Pass cart items to CartTable */}
          </div>
        </div>

        {/* Cart Total Section */}
        <div className="col-lg-4 mb-4">
          <div className="card p-4">
            <CartTotal cartItems={cartItems} />{" "}
            {/* Pass cart items to CartTotal */}
            <Button
              variant="contained"
              className="btn btn-primary mt-3 w-100"
              onClick={handleCheckout}
              disabled={cartItems.length === 0 || ["loading", "error"].includes(catalogStatus) || cartItems.some(item => item.unavailable)} // Disable if no items in cart
            >
              Fortsätt till kassan
            </Button>
          </div>
        </div>
      </div>

      {/* Product Related Section */}
      <div className="product-related-section mb-5">
        <h2 className="mb-4 text-center">{t("CusAlso")}</h2>
        <ProductSlider
          products={
            recentlyViewedProducts.length < 2
              ? randomProducts
              : isCookieConsentAccepted
              ? recentlyViewedProducts
              : randomProducts
          }
        />
      </div>

      {/* Sign In / Sign Up Modal */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle className="text-center">
          <Tabs value={tabIndex} onChange={handleTabChange} centered>
            <Tab label="Sign In" />
            <Tab label="Sign Up" />
          </Tabs>
        </DialogTitle>
        <DialogContent dividers>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "300px" }}
          >
            {tabIndex === 0 ? <LoginForm /> : <SignupForm />}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CartContainer;
